import { Info } from 'lucide-react'
import { HELP_CONTENT, type HelpTopic } from '@/content/help'
import { useIsCoarsePointer } from '@/lib/usePointerType'
import { cn } from '@/lib/utils'
import { Button } from '@/ui/shadcn/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/ui/shadcn/dialog'
import { Popover, PopoverContent, PopoverTrigger } from '@/ui/shadcn/popover'

function HelpLines({ topic }: { topic: HelpTopic }) {
  const content = HELP_CONTENT[topic]
  if (!content) throw new Error(`Info tip has no content for help topic "${topic}"`)
  return (
    <div className="space-y-2 text-sm text-muted-foreground">
      {content.lines.map((line) => <p key={line}>{line}</p>)}
    </div>
  )
}

export function InfoTip({ topic, className, testId }: { topic: HelpTopic; className?: string; testId?: string }) {
  const isCoarse = useIsCoarsePointer()
  const content = HELP_CONTENT[topic]
  if (!content) throw new Error(`Info tip has no content for help topic "${topic}"`)
  const trigger = (
    <Button type="button" variant="ghost" size="icon" className={cn('size-7 text-muted-foreground', className)} aria-label={`About ${content.title}`} data-testid={testId}>
      <Info className="size-4" aria-hidden="true" />
    </Button>
  )
  if (isCoarse) {
    return (
      <Dialog>
        <DialogTrigger asChild>{trigger}</DialogTrigger>
        <DialogContent className="!bottom-0 !left-0 !top-auto !w-full !max-w-none !translate-x-0 !translate-y-0 !rounded-b-none !rounded-t-2xl">
          <DialogHeader><DialogTitle>{content.title}</DialogTitle></DialogHeader>
          <HelpLines topic={topic} />
        </DialogContent>
      </Dialog>
    )
  }
  return (
    <Popover>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent align="end">
        <h3 className="mb-3 font-semibold">{content.title}</h3>
        <HelpLines topic={topic} />
      </PopoverContent>
    </Popover>
  )
}
